import React, { ComponentProps } from "react";

import { Calendar as CalendarIcon } from "react-feather";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { setHours, subYears } from "date-fns";

import { DobPickerProps } from "./types";

const DobPicker: React.FC<DobPickerProps> = ({
  value = null,
  onValueChange = () => {},
  name = "",
  disabled = false,
  maxDate = subYears(new Date(), 16),
  minDate = subYears(new Date(), 110),
  label = "Date of birth",
  minDateMessage = "Please check your date of birth is correct",
  maxDateMessage = "Please check your date of birth is correct",
  ...restProps
}: DobPickerProps) => {
  const handleDateChange: ComponentProps<
    typeof KeyboardDatePicker
  >["onChange"] = newDate => {
    // We need to normalise the time on the dob to midday as by default it's 00:00 and
    // when converted to ISO string, the time can get shifted back an hour, changing the date
    const newDateWithNormalisedTime = newDate ? setHours(newDate, 12) : newDate;
    onValueChange(newDateWithNormalisedTime);
  };

  return (
    <KeyboardDatePicker
      inputVariant="outlined"
      name={name}
      label={label}
      value={value}
      onChange={handleDateChange}
      disabled={disabled}
      minDate={minDate}
      minDateMessage={minDateMessage}
      maxDate={maxDate}
      maxDateMessage={maxDateMessage}
      placeholder="dd/mm/yyyy"
      format="dd/MM/yyyy"
      inputProps={{
        inputMode: "decimal",
        "data-test": "dob-picker-input",
      }}
      disableFuture
      fullWidth
      keyboardIcon={<CalendarIcon />}
      {...restProps}
    />
  );
};

export default DobPicker;
